import { SortStart } from 'react-sortable-hoc';

export const columnHeaderContent = (
    cName: string,
    subText?: string,
    className?: string,
): JSX.Element => (
    <td>
        <div className={`text-11 font-700 uppercase text-neutral-3 ${className ? className : ''}`}>
            {cName}
        </div>

        {subText && <div className="text-12 text-neutral-6">{subText}</div>}
    </td>
);

export const headerStyle = () => ({
    style: {
        backgroundColor: 'rgba(244, 246, 249, var(--tw-bg-opacity))',
        padding: '8px 12px',
    },
});

// get sample width and apply to dragging row, as it is not fixed, relatie to viewport instead of container
export const handleTableDragWidth = (params: SortStart, dragContainerId: string): void => {
    const dContainer = document.getElementById(dragContainerId);
    const widths: number[] = [];
    if (dContainer?.children.length) {
        for (let j = 0; j < dContainer?.children.length; j++) {
            if (dContainer?.children[j]?.children?.length) {
                for (let i = 0; i < dContainer?.children[j]?.children?.length; i++) {
                    widths.push(dContainer?.children[j]?.children[i].clientWidth);
                }
                break;
            }
        }
    }

    params.node.childNodes.forEach((_, index: number): void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        params.helper.childNodes[index].style.width = widths[index] + 'px';
    });
};
